import toggles from 'feature-toggles'

let requests: any[] = []
let processing = false

const process = async () => {
  if (processing) return
  processing = true
  while(requests.length) {
    const {url, fetchData, resolve, reject} = requests.shift()
    try {
      const response = await fetch(url, fetchData)
      resolve(response)
    } catch (error) {
      reject(error)
    } 
  }
  processing = false
}

const _fetch = async (url, fetchData): Promise<Response> => {
  if (!toggles.throttleRequests()) return fetch(url, fetchData)
  let resolve, reject
  const promise = new Promise((_resolve, _reject) => {resolve = _resolve; reject = _reject})
  requests.push({url, fetchData, resolve, reject})
  process()
  return promise as Promise<Response>
}

export default _fetch